/*ěščřžýáíéúů*/
document.addEventListener("DOMContentLoaded", function () {
    // Sticky submenu funkcionalita
    function initStickySubmenu() {
        const header = document.querySelector("header, .site-header");
        const submenu = document.querySelector(".submenu-function");
        const adminBar = document.querySelector("#wpadminbar");

        if (!header || !submenu) return;

        let headerHeight = header.offsetHeight;
        let adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        let submenuHeight = submenu.offsetHeight;
        let submenuOffset = submenu.getBoundingClientRect().top + window.pageYOffset;
        let isSticky = false;
        let stickyPlaceholder = null;

        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const triggerPoint = submenuOffset - headerHeight - adminBarHeight;

            if (scrollTop >= triggerPoint) {
                if (!isSticky) {
                    // Vytvoř placeholder pro zachování layoutu
                    stickyPlaceholder = document.createElement("div");
                    stickyPlaceholder.style.height = submenuHeight + "px";
                    stickyPlaceholder.className = "submenu-sticky-placeholder";
                    submenu.parentNode.insertBefore(stickyPlaceholder, submenu);

                    // Aktivuj sticky submenu
                    submenu.classList.add("sticky");
                    submenu.style.top = adminBarHeight + "px";

                    // Animace schování hlavičky
                    header.style.transform = `translateY(-100%)`;
                    header.style.transition = "transform 0.3s ease";

                    isSticky = true;
                }
            } else {
                if (isSticky) {
                    // Deaktivuj sticky submenu
                    submenu.classList.remove("sticky");
                    submenu.style.top = "";

                    // Zobraz hlavičku
                    header.style.transform = "translateY(0)";

                    // Odstraň placeholder
                    if (stickyPlaceholder) {
                        stickyPlaceholder.remove();
                        stickyPlaceholder = null;
                    }

                    isSticky = false;
                }
            }
        }

        // Throttle scroll event pro performance
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
            }
        }

        window.addEventListener("scroll", () => {
            requestTick();
            ticking = false;
        });

        // Recalculate na resize
        window.addEventListener("resize", () => {
            headerHeight = header.offsetHeight;
            adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
            submenuHeight = submenu.offsetHeight;
            submenuOffset = submenu.getBoundingClientRect().top + window.pageYOffset;

            // Pokud je sticky, aktualizuj top pozici
            if (isSticky) {
                submenu.style.top = adminBarHeight + "px";
            }
        });
    }

    // Inicializuj sticky submenu
    initStickySubmenu();

    // SwiperJS pro testimonials
    function initTestimonialSwiper() {
        const testimonialSwiper = new Swiper(".testimonial__content", {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".buttons__next",
                prevEl: ".buttons__prev",
            },
            on: {
                slideChange() {
                    // Reset všechny progress bary
                    const allProgressBars = document.querySelectorAll(".testimonial__progress .progress-fill");
                    allProgressBars.forEach((bar) => {
                        bar.style.width = "0%";
                    });

                    // Spusť animaci pro aktivní slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
                init() {
                    // Spusť animaci pro první slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
            },
        });
    }

    // Inicializuj testimonial swiper
    if (document.querySelector(".testimonial__content")) {
        initTestimonialSwiper();
    }

    // Case Study Tabs funkcionalita s GSAP animacemi
    function initCaseStudyTabs() {
        const tabs = document.querySelectorAll(".case-study-tab");
        const contents = document.querySelectorAll(".case-study-content");

        if (tabs.length === 0 || contents.length === 0) return;

        // Nastav počáteční stav pro všechny obsahy (kromě prvního)
        contents.forEach((content, index) => {
            if (index === 0) {
                gsap.set(content, { display: "flex", opacity: 1, y: 0 });
            } else {
                gsap.set(content, { display: "none", opacity: 0, y: 30 });
            }
        });

        tabs.forEach((tab) => {
            tab.addEventListener("click", function () {
                const tabIndex = parseInt(this.getAttribute("data-tab"));
                const targetContent = document.querySelector(`[data-content="${tabIndex}"]`);
                const currentActiveContent = document.querySelector(".case-study-content.active");

                // Pokud je již tento tab aktivní, neděláme nic
                if (this.classList.contains("active")) return;

                // Animace pro tabs
                tabs.forEach((t) => t.classList.remove("active"));
                this.classList.add("active");

                // GSAP animace pro přepnutí obsahu
                const timeline = gsap.timeline();

                if (currentActiveContent && currentActiveContent !== targetContent) {
                    // Fade out současný obsah
                    timeline.to(currentActiveContent, {
                        opacity: 0,
                        y: -20,
                        duration: 0.3,
                        ease: "power2.out",
                        onComplete: () => {
                            gsap.set(currentActiveContent, { display: "none" });
                            currentActiveContent.classList.remove("active");
                        },
                    });
                }

                if (targetContent) {
                    // Fade in nový obsah
                    timeline.set(targetContent, { display: "flex" }).to(targetContent, {
                        opacity: 1,
                        y: 0,
                        duration: 0.4,
                        ease: "power2.out",
                        onStart: () => {
                            targetContent.classList.add("active");
                        },
                    });

                    // Animace pro jednotlivé elementy v obsahu
                    timeline
                        .from(
                            targetContent.querySelectorAll(".col-right__content-icons .icon"),
                            {
                                scale: 0.8,
                                opacity: 0,
                                duration: 0.3,
                                stagger: 0.1,
                                ease: "back.out(1.7)",
                            },
                            "-=0.2",
                        )
                        .from(
                            targetContent.querySelector(".col-right__content-headline"),
                            {
                                y: 20,
                                opacity: 0,
                                duration: 0.3,
                                ease: "power2.out",
                            },
                            "-=0.1",
                        )
                        .from(
                            targetContent.querySelectorAll(".desc-lists .item"),
                            {
                                x: -20,
                                opacity: 0,
                                duration: 0.3,
                                stagger: 0.1,
                                ease: "power2.out",
                            },
                            "-=0.1",
                        )
                        .from(
                            targetContent.querySelector(".col-right__content-text-button"),
                            {
                                y: 20,
                                opacity: 0,
                                duration: 0.3,
                                ease: "power2.out",
                            },
                            "-=0.2",
                        );
                }
            });
        });
    }

    // Inicializuj case study tabs
    if (document.querySelector("#case-study-tabs")) {
        initCaseStudyTabs();
    }

    // SwiperJS pro posts slider
    function initPostsSwiper() {
        const postsSwiper = new Swiper(".posts__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: true,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-posts__next",
                prevEl: ".buttons-posts__prev",
            },
        });
    }

    // Inicializuj posts swiper
    if (document.querySelector(".posts__slider-swiper")) {
        initPostsSwiper();
    }

    // SwiperJS pro posts slider
    function initInstalationSwiper() {
        const postsSwiper = new Swiper(".instalation__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: false,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-instalation__next",
                prevEl: ".buttons-instalation__prev",
            },
        });
    }
});
